import React from 'react';
import clsx from 'clsx';
import formStyles from '../table/AppTable.module.scss';

type OwnProps = {
  value: string;
  onClickHandler?: () => void;
  disabled?: boolean;
  isActive?: boolean;
  testId?: string;
};

export const Chip = (props: OwnProps) => {
  const { onClickHandler, isActive, value, disabled, testId } = props;

  return (
    <div
      className={clsx(
        formStyles.pageText,
        formStyles.fitContent,
        isActive && formStyles.activeOption,
        disabled && formStyles.disabledChip,
      )}
      onClick={!disabled ? onClickHandler : undefined}
      data-test-id={testId}
    >
      {value}
    </div>
  );
};
